import { render, staticRenderFns } from "./RadiobuttonCard.vue?vue&type=template&id=3dfaf4f7&"
import script from "./RadiobuttonCard.vue?vue&type=script&lang=js&"
export * from "./RadiobuttonCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports